import { render } from "./students_barcodes_print.vue?vue&type=template&id=043d0388&scoped=true"
import script from "./students_barcodes_print.vue?vue&type=script&lang=js"
export * from "./students_barcodes_print.vue?vue&type=script&lang=js"

import "./students_barcodes_print.vue?vue&type=style&index=0&id=043d0388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043d0388"]])

export default __exports__